import * as React from 'react';

declare const I18n;

type Props = {
  title: string;
  description?: string;
  id: number;
  handleDelete(id: number): void;
};

const CategoryCard: React.FunctionComponent<Props> = ({
  title,
  description = '',
  id,
  handleDelete,
}: Props): JSX.Element => {
  return (
    <div className="category-card">
      <div className="category-card__admin">
        <a
          href={`/admin/courses/categories/${id}/edit`}
          aria-label={I18n.t('views.common.edit')}
        >
          <i className="fal fa-edit" />
        </a>
        <button
          type="button"
          id={`delete_${id}`}
          onClick={(e) => {
            e.preventDefault();
            if (confirm(I18n.t('views.forms.messaging.confirm_delete'))) {
              handleDelete(id);
            }
          }}
          aria-label={I18n.t('views.common.delete')}
        >
          <i className="fal fa-trash" />
        </button>
      </div>

      <div id={`category_title_${id}`} className="category-card__title">
        {title}
      </div>

      {description && (
        <div id={`category_description_${id}`} className="category-card__description">
          {description}
        </div>
      )}
    </div>
  );
};

export default CategoryCard;
